<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>e-Ginga Ansião - Politica de Privacidade</title>
</head>
<body>
    <ng-container *transloco="let t">
    <div class="container">
        <div class="header">
            <a routerLink="/"><img src="./img/logo.png" alt="Company Logo" class="logo"></a>
            <h1>{{ t('privacy_policy.title') }}</h1>
            <div class="language-selector">
            <button (click)="changelanguage('en')" class="btn-lang">ENG</button>
            <button (click)="changelanguage('pt')" class="btn-lang">PT</button>
            </div>
        </div>
        <div class="content">
            <p>{{ t('privacy_policy.content.p1') }}</p>
            <p>{{ t('privacy_policy.content.p2') }}</p>
            <p>{{ t('privacy_policy.content.p3') }}</p>
            <p>{{ t('privacy_policy.content.p4') }}</p>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.fundamentos.title') }}</strong></p>
            <p>{{ t('privacy_policy.sections.fundamentos.p1') }}</p>
            <p>{{ t('privacy_policy.sections.fundamentos.p2') }}</p>
            <p>{{ t('privacy_policy.sections.fundamentos.p3') }}</p>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.consentimento.title') }}</strong></p>
            <p>{{ t('privacy_policy.sections.consentimento.p1') }}</p>
            <p>{{ t('privacy_policy.sections.consentimento.p2') }}</p>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.acesso.title') }}</strong></p>
            <p>{{ t('privacy_policy.sections.acesso.intro') }}</p>
            <ul>
                <li *ngFor="let item of t('privacy_policy.sections.acesso.list')">
                    <p>{{ item }}</p>
                </li>
            </ul>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.portability.title') }}</strong></p>
            <p>{{ t('privacy_policy.sections.portability.p1') }}</p>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.esquecimento.title') }}</strong></p>
            <p>{{ t('privacy_policy.sections.esquecimento.intro') }}</p>
            <ul>
        <li *ngFor="let item of t('privacy_policy.sections.esquecimento.list')">
            <p>{{ item }}</p> </li>
        </ul>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.responsability.title') }}</strong></p>
            <p>{{ t('privacy_policy.sections.responsability.p1') }}</p>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.dpo.title') }}</strong></p>
            <p>{{ t('privacy_policy.sections.dpo.intro') }}</p>
            <ul>
                <li *ngFor="let task of t('privacy_policy.sections.dpo.list')">
                    <p>{{ task }}</p>
                </li>
            </ul>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.notification.title') }}</strong></p>
            <p>{{ t('privacy_policy.sections.notification.p1') }}</p>
            <p><br/></p>
            <p><strong>{{ t('privacy_policy.sections.contacts.title') }}</strong></p>
            <p [innerHTML]="t('privacy_policy.sections.contacts.p1')"></p>
            <p><br/></p>
        </div>
        <div class="footer">
            <span>&copy; 2026 <script>document.write(new Date().getFullYear())</script> <a href="https://www.wegoshare.com" target="_blank">Wegoshare</a>. {{ t('footer.rights') }}</span>
            <span>
                <div class="footer-links">
                    <a routerLink="/">{{ t('footer.home') }}</a>&nbsp;&nbsp;&nbsp;
                    <a routerLink="/Politica-de-Privacidade">{{ t('footer.privacy') }}</a>&nbsp;&nbsp;&nbsp;
                    <a routerLink="/Acordo-de-Utilização">{{ t('footer.agreement') }}</a>
                </div>
            </span>
        </div>
    </div>
</ng-container>
</body>
</html>